// extracted by mini-css-extract-plugin
export var lg = "_3x-4";
export var md = "_3x-3";
export var sm = "_3x-2";
export var xs = "_3x-1";
export var xxs = "_3x-0";